export const ROUTE_PERMISSIONS = {
  customers: ['viewCustomer'],
  samples: ['viewSamples'],
  sampleCreate: ['addSample'],
  orders: ['viewOrders'],
  orderView: ['viewOrder'],
  orderCreate: ['addOrder'],
  orderEdit: ['editOrder'],
  payments: ['viewPayments'],
  debtors: ['viewPayments'],
  oldPayments: ['viewOldPayment'],
  authors: ['viewAuthors'],
  books: ['viewBooks'],
  bookView: ['viewBook'],
  royalties: ['viewRoyalties', 'viewRoyalty'],
  royaltyPayments: ['viewRoyalties', 'viewRoyalty'],
  users: ['viewUsers'],
  permissions: ['editUser'],
  stores: [
    'releaseOrder',
    'returnOrder',
    'releaseSample',
    'returnSample',
    'addStock',
  ],
  stock: ['addStock'],
  printRequests: ['viewPrints'],
  publishingReports: ['viewPublishingReport'],
  accountingReports: ['viewAccountReport'],
  storesReports: ['viewStoresReport'],
  managerInsights: ['viewManagerInsights'],
  auditLog: ['viewAuditLog'],
}

export const MENU_PERMISSIONS = {
  customers: ROUTE_PERMISSIONS.customers,
  samples: ROUTE_PERMISSIONS.samples,
  orders: ROUTE_PERMISSIONS.orders,
  payments: ROUTE_PERMISSIONS.payments,
  debtors: ROUTE_PERMISSIONS.debtors,
  oldPayments: ROUTE_PERMISSIONS.oldPayments,
  authors: ROUTE_PERMISSIONS.authors,
  books: ROUTE_PERMISSIONS.books,
  royalties: ROUTE_PERMISSIONS.royalties,
  users: ROUTE_PERMISSIONS.users,
  stores: ROUTE_PERMISSIONS.stores,
  stock: ROUTE_PERMISSIONS.stock,
  printRequests: ROUTE_PERMISSIONS.printRequests,
  publishingReports: ROUTE_PERMISSIONS.publishingReports,
  accountingReports: ROUTE_PERMISSIONS.accountingReports,
  storesReports: ROUTE_PERMISSIONS.storesReports,
  managerInsights: ROUTE_PERMISSIONS.managerInsights,
  auditLog: ROUTE_PERMISSIONS.auditLog,
}
